<template><div>Table</div></template>
<script>
export default {
  name: 'unit-table',
}
</script>
<style lang="scss">
</style>
